import SectionHeading from "../components/SectionHeading";
import { Trophy, Users, BookOpen, Heart, Flag, Award } from "lucide-react";

const HUDDLE_IMG = "/assets/team-photo.jpg";

const values = [
  { icon: Trophy, title: "Excellence", body: "Competing at an elevated level so every athlete is challenged to reach their full potential." },
  { icon: Users, title: "Teamwork", body: "Camaraderie, respect, and unwavering commitment to each other." },
  { icon: BookOpen, title: "Scholastic", body: "Emphasizing achievement in the classroom as much as on the field." },
  { icon: Heart, title: "Integrity", body: "Hard work, dedication, and doing right when no one is watching." },
  { icon: Flag, title: "Leadership", body: "Preparing role models for the community and the next generation." },
  { icon: Award, title: "Sportsmanship", body: "Honoring opponents, officials, and the game itself." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      {/* Hero */}
      <section className="relative py-28 md:py-40 overflow-hidden border-b border-black/10 bg-black">
        <div className="absolute inset-0 bg-cover bg-center opacity-85" style={{ backgroundImage: `url(${HUDDLE_IMG})` }} />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/20" />
        <img src="/assets/titans-c-logo.jpg" alt="" aria-hidden className="hidden md:block absolute -right-20 top-1/2 -translate-y-1/2 w-[520px] opacity-[0.18] pointer-events-none select-none mix-blend-screen" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <span className="font-display text-xs uppercase tracking-[0.3em] text-[#2D5F3F] font-bold">About the Organization</span>
          <h1 className="mt-4 font-display text-5xl sm:text-7xl lg:text-8xl font-black uppercase leading-[0.9] text-[#FDFBF7]">
            Built on <span className="text-[#2D5F3F]">grit</span>,
            <br /> raised by <span className="text-[#FDFBF7]">community</span>.
          </h1>
        </div>
      </section>

      {/* Mission */}
      <section className="py-24 md:py-32 bg-[#F5EFE0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <SectionHeading eyebrow="Mission" title="Shaping the Next Generation" />
          </div>
          <div className="lg:col-span-8 space-y-6 text-black/80 leading-relaxed text-lg">
            <p>
              Cawston Titans Youth Sports Organization is committed to fostering a safe, positive, and empowering
              environment where young athletes can develop their skills in football, cheer, basketball, and track &
              field. Through structured coaching and mentorship, we aim to instill values that extend far beyond the
              game-principles of hard work, dedication, integrity, and teamwork.
            </p>
            <p>
              Our mission is to shape well-rounded individuals who exemplify sportsmanship, respect, and a keen sense
              of community. We believe that athletic excellence and character development go hand in hand. By
              emphasizing scholastic achievement, citizenship, and leadership, we prepare our participants for success
              both on and off the field.
            </p>
            <p>
              As an organization, we are dedicated to maintaining an elevated level of competition, ensuring that
              every athlete is challenged to reach their full potential. We encourage perseverance, discipline, and
              commitment to personal and collective growth. Through the spirit of camaraderie and excellence, Cawston
              Titans Youth Sports Organization strives to inspire the next generation of leaders, athletes, and role
              models.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-[#EFE9D9] py-24 border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <SectionHeading eyebrow="Core Values" title="What We Stand For" align="center" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v) => (
              <div
                key={v.title}
                data-testid={`value-${v.title.toLowerCase()}`}
                className="group bg-white border border-black/10 p-8 hover:border-[#2D5F3F]/60 hover:-translate-y-1 transition-all"
              >
                <v.icon className="w-8 h-8 text-[#2D5F3F]" strokeWidth={2.2} />
                <h3 className="mt-6 font-display text-2xl font-black uppercase text-[#0A0A0A]">{v.title}</h3>
                <p className="mt-3 text-black/70 leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
